<template>
  <div>
    <page-title icon="fa fa-shopping-cart" main="Promoções" sub="Campanha Por Volume" :help="true"
      titleHelp="Ajuda - Campanhas Por Volume" content="Página responsável por listar Campanhas Por Volume
Para criação pressione o botão no canto superior direito 'Cadastro'.
Para alteração de um vendedor basta ir com o mouse em ações e clicar em Editar.
Para verificar os Descontos basta ir com o mouse em ações e clicar em 'Descontos'.
Para verificar os Produtos basta ir com o mouse em ações e clicar e clicar em Produtos.
">
      <template v-slot:actions>
        <base-button @click="newCampaign" type="neutral" class="ml-3" size="sm"
          v-if="$can('update', 'user')">Cadastro</base-button>
      </template>
    </page-title>
    <modal :show.sync="modals.modal0" id="cadastrar-seções">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Cadastrar Campanhas</h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-md-12">
              <base-input label="Nome" placeholder="Nome da campanha" v-model="campaign.name" :required="true"
                :rules="{ required: true }" name="name" />
            </div>
            <div class="col-md-12">
              <label class="form-control-label d-block mb-3">Vigência</label>
              <base-input addon-left-icon="ni ni-calendar-grid-58" :required="true">
                <el-date-picker
                  v-model="dateRange"
                  :key="dateRange.join()"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Data início"
                  end-placeholder="Data fim"
                  unlink-panels
                  :required="true"
                  prefix-icon="fa fa-calendar"
                  format="d 'de' MMMM 'de' yyyy"
                  rules="required"
                  :editable="true"
                  :clearable="false"
                  />
              </base-input>
              <span v-if="campaign.start_date || campaign.end_date" class="custom-clear-icon" @click="handleClearIconClick">
                <i class="button-class fas fa-times-circle"></i>
              </span>
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal0 = false">Fechar</base-button>
        <base-button type="success" @click="save">Salvar</base-button>
      </template>
    </modal>
    <card>
      <div slot="header">
        <span>Campanha Por Volume</span>
      </div>
      <form @submit.prevent.capture="setData()">
        <div class="row">
          <div class="col-md-10">
            <div>
              <base-input label="Nome" placeholder="Nome da Campanha" v-model="filter.name" />
            </div>
          </div>
          <div class="col-md-2 mb-3">
            <div style="margin-top: 2rem">
              <base-button icon type="primary" v-on:click="setData()" style="width: 100%">
                <span class="btn-inner--icon">
                  <i class="fa fa-search"></i>
                </span>
                <span class="btn-inner--text">Pesquisar</span>
              </base-button>
            </div>
          </div>
        </div>
      </form>
      <el-table v-loading="isLoading" class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light" :data="campaigns" ref="campaigns">
        <el-table-column label="Nome" prop="name" min-width="200px" sortable />
        <el-table-column label="Data Início" v-slot="{ row }" min-width="140px" sortable>
          {{ row.start_date | humanDate }}
        </el-table-column>
        <el-table-column label="Data Fim" v-slot="{ row }" min-width="140px" sortable>
          {{ row.end_date | humanDate }}
        </el-table-column>
        <el-table-column label="Ações" min-width="120px" v-slot="{ row }">
          <div class="row">
            <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <router-link class="dropdown-item"
                  :to="{ name: 'campaign_discounts', params: { campaign_id: row.id } }">Descontos</router-link>
                <router-link class="dropdown-item"
                  :to="{ name: 'campaign_products', params: { campaign_id: row.id } }">Produtos</router-link>
                <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
                <a class="dropdown-item" href="#" @click="remove(row)">Excluir</a>

              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination @input="changePage()" v-model="paginated_data['current']" :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"></base-pagination>
      </div>
    </card>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Select,
  Option,
  DatePicker
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { ValidationProvider, extend } from "vee-validate";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  name: "app",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PageTitle,
    Multiselect,
    ValidationProvider,
    flatPicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      modals: {
        modal0: false
      },
      campaigns: [],
      campaign: {},
      filter: {},
      isLoading: false,
      filtered: false,
      paginated_data: [],
      formData: {},
      end_date: 'Data de Fim',
      start_date: 'Data de Início',
    }
  },
  created() {
    this.setData();
    // this.setStaticData();
  },
  methods: {
    rowClicked(row) {
      // this.$refs.discounts.toggleRowExpansion(row);
    },
    async setData() {
      this.isLoading = true;
      //  Adicionando valores default a query e ao número da página se não definidos
      // if (typeof q === "undefined" || this.emptyFilter) q = null;

      try {
        const response = await this.$http.secured.get(`/api/v1/campaigns`, {
          params: {
            campaign_id: this.$route.params.campaign_id,
            page: this.paginated_data['current'] || 1,
            q: {
              name: this.filter.name,
              campaign_type: 'cpv_bayer',
            }
          },
        })
        // setando dados de paginação e a collection produtos
        this.paginated_data = response.data;
        this.campaigns = this.paginated_data["campaigns"];
        this.isLoading = false;
      } catch (error) {
        console.error("[campaigns][setData] Request error: ", error)
      }
    },
    remove(campaign) {
      this.$http.secured
        .delete(`/api/v1/campaigns/${campaign.id}`, campaign)
        .then(response => {
          console.log("response: ", response.data)
          this.$toasted.global.defaultSuccess();
          this.setData();
        })
        .catch(error => {
          console.error("[campaigns][remove] Request error: ", error)
          this.$refs.observer.setErrors(this.errors)
        });
    },
    changePage() {
      let filterInput = null;

      if (this.filtered) filterInput = this.filter;
      // Se algo foi pesquisado passa o parametro de filtro
      // Se não é passado parâmetro nulo
      this.setData();
    },
    newCampaign() {
      this.campaign = {}
      this.modals.modal0 = true
    },
    edit(campaign) {
      this.campaign = campaign
      this.end_date = campaign.end_date
      this.start_date = campaign.start_date
      this.modals.modal0 = true
    },
    async save() {
      const validForm = await this.$refs.observer.validate()

      if (!validForm) {
        this.$toasted.global.defaultError({ msg: "Favor preencher todos os campos." });
        return;
      }

      this.$http
        .secured(this.reqParams)
        .then(response => {
          console.log("response: ", response.data)
          this.$toasted.global.defaultSuccess();
          this.setData();
          this.modals.modal0 = false;
          this.resetInputs()
          this.$refs.observer.reset();
        })
        .catch(error => {
          console.error("[campaigns][save] Request error: ", error)
          this.$refs.observer.setErrors(this.errors)
        });
    },
    resetInputs() {
      this.filter = {}
      this.campaign = {}
    },
    handleClearIconClick() {
      if (this.campaign.start_date || this.campaign.end_date) {
        this.campaign.start_date = '';
        this.campaign.end_date = '';
      }
    }
  },
  computed: {
    reqParams: function () {
      if (this.campaign.hasOwnProperty("id")) {
        return {
          url: `/api/v1/campaigns/${this.campaign.id}`,
          method: "patch",
          data: {
            // Campaing_type: Index = 2
            campaign_type: 'cpv_bayer',
            ...this.campaign,
          },
        };
      }
      return {
        url: "/api/v1/campaigns",
        method: "post",
        data: {
          // Campaing_type: Index = 2
          campaign_type: 'cpv_bayer',
          ...this.campaign,
        },
      };
    },
    emptyFilter: function () {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    normalizedFilter: function () {
      let filter = this.filter;
      for (let key in filter) {
        // replacing objects by ids
        if (
          filter.hasOwnProperty(key) &&
          typeof filter[key] == 'object'
        ) {
          if (filter[key].hasOwnProperty('id')) {
            filter[key + '_id'] = filter[key].id
            delete filter[key]
          } else {
            filter[key] = filter[key].value
          }
        }
        // removing empty fields
        if (filter[key] == "") {
          delete filter[key];
        }
      }

      return filter;
    },
    dateRange: {
      get: function () {
        // eslint-disable-next-line
        /* eslint-disable */

        return [this.campaign.start_date, this.campaign.end_date];
      },
      set: function (range) {
        this.campaign = Object.assign({}, this.campaign, {
          start_date: range[0],
          end_date: range[1],
        })
      },
    },
  },
  watch: {
    start_date: function () {
      this.campaign.start_date = this.start_date
    },
    end_date: function () {
      this.campaign.end_date = this.end_date
    }
  }
};
</script>

<style scoped>
.button-class {
  color: #C0C4CC;
  position: absolute;
  top: 58%;
  right: 30px;
  transform: translateY(-50%);
}
</style>
